// extracted by mini-css-extract-plugin
export default {"reindex-section":"ReindexAlert_reindex-section__eByiG","reindex-shadow":"ReindexAlert_reindex-shadow__Ars0g"};